import { lazy, Suspense, FC } from "react";

const Bookings = lazy(() => import("./Bookings"));

const BookingsLazy: FC = () => (
  <Suspense fallback={null}>
    <Bookings />
  </Suspense>
);

export default BookingsLazy;
